export const CHART_COLORS = {
  red: {
    "50": "#FFF2F4",
    "100": "#FFD8E0",
    "200": "#FFBDCB",
    "300": "#FF859E",
    "400": "#FC5275",
    "500": "#EA2A51",
    "600": "#D20E36",
    "700": "#B50025",
    "800": "#90001D",
    "900": "#640014",
    "950": "#32000A",
  },
  orange: {
    "50": "#FFF6F2",
    "100": "#FFE5D7",
    "200": "#FFD4BC",
    "300": "#FFAD84",
    "400": "#FB8951",
    "500": "#E96929",
    "600": "#D24E0D",
    "700": "#B43C00",
    "800": "#8F3000",
    "900": "#632100",
    "950": "#321100",
  },
  yellow: {
    "50": "#FFFCF2",
    "100": "#FFF8D3",
    "200": "#FFF4B2",
    "300": "#FFE573",
    "400": "#FFD439",
    "500": "#FFC208",
    "600": "#E4AC00",
    "700": "#C39200",
    "800": "#9A7400",
    "900": "#6B5000",
    "950": "#362900",
  },
  green: {
    "50": "#F9FFF2",
    "100": "#EAF8D6",
    "200": "#DBF1BC",
    "300": "#BEE688",
    "400": "#A3D65C",
    "500": "#8CC936",
    "600": "#75B71A",
    "700": "#5F9F07",
    "800": "#4C7F04",
    "900": "#355902",
    "950": "#1A2D00",
  },
  jade: {
    "50": "#F2FFF8",
    "100": "#D4FBE7",
    "200": "#B7F6D7",
    "300": "#80EDB6",
    "400": "#51E098",
    "500": "#2CCE7D",
    "600": "#11BB66",
    "700": "#01A252",
    "800": "#018241",
    "900": "#005A2D",
    "950": "#002E17",
  },
  blue: {
    "50": "#F2FCFF",
    "100": "#D7F7FF",
    "200": "#BCF2FF",
    "300": "#84E2FF",
    "400": "#51D0FB",
    "500": "#29B9E9",
    "600": "#0DA0D2",
    "700": "#0087B4",
    "800": "#006B8F",
    "900": "#004A63",
    "950": "#002632",
  },
  indigo: {
    "50": "#F2F6FF",
    "100": "#D9E4FC",
    "200": "#C0D3F9",
    "300": "#8CAEF2",
    "400": "#5F8CE6",
    "500": "#3C6FD6",
    "600": "#1D54C2",
    "700": "#083DA7",
    "800": "#053086",
    "900": "#02215D",
    "950": "#01102F",
  },
  violet: {
    "50": "#FAF2FF",
    "100": "#EAD7F4",
    "200": "#DABEEA",
    "300": "#BF8CDA",
    "400": "#A463C7",
    "500": "#903EBC",
    "600": "#7C20AD",
    "700": "#660C96",
    "800": "#510779",
    "900": "#380355",
    "950": "#1C012B",
  },
  pink: {
    "50": "#FFF2F9",
    "100": "#FCD0EA",
    "200": "#F8B0DA",
    "300": "#F075BD",
    "400": "#E648A4",
    "500": "#D7248D",
    "600": "#C20B76",
    "700": "#A80062",
    "800": "#86004E",
    "900": "#5D0036",
    "950": "#2F001C",
  },
};

type ChartColorShade = keyof (typeof CHART_COLORS)[keyof typeof CHART_COLORS];

// Ordered to maximise perceptual separation between consecutive colours —
// warm and cool hues are interleaved so adjacent series never share a hue family.
const CHART_COLOR_ORDER: (keyof typeof CHART_COLORS)[] = [
  "orange",
  "blue",
  "red",
  "indigo",
  "yellow",
  "violet",
  "green",
  "pink",
  "jade",
];

export function getChartColors(shade: ChartColorShade = "500"): string[] {
  return CHART_COLOR_ORDER.map((family) => CHART_COLORS[family][shade]);
}
